export default __webpack_public_path__ + "static/media/img-0600-liechtenstein-full-face.8f6fa57a.png";